import { render } from "./FooterComponent.vue?vue&type=template&id=5da57874&scoped=true"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=5da57874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da57874"]])

export default __exports__